import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Modal, Toast, ToastContainer } from 'react-bootstrap';
import AppSpinner from "../Spinner/AppSpinner";
import CopyFooter from "../CopyFooter/CopyFooter";
import { BASE_URL } from '../../constants';
import { apiFetch } from "../../utils/apiFetch";
import AddSectionModal from '../AddSectionModal/AddSectionModal';
import SectionLectures from '../SectionLectures/SectionLectures';

const thStyle = {
  padding: '8px 12px', textAlign: 'left',
  borderBottom: '1px solid #e5e7eb', color: '#374151',
  fontWeight: 700, fontSize: 11, textTransform: 'uppercase', whiteSpace: 'nowrap'
};
const tdStyle = { padding: '6px 12px', color: '#374151', whiteSpace: 'nowrap' };
const labelStyle = {
  display: 'block', fontSize: 11, fontWeight: 700, color: '#374151',
  textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 5
};
const inputStyle = {
  width: '100%', border: '1px solid #e5e7eb', borderRadius: 6,
  padding: '7px 10px', fontSize: 12, color: '#111827', background: '#fff',
  outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit'
};

const parseLang = (str, lang = 'Az') => {
  if (!str) return '';
  const regex = new RegExp(`${lang}:::([\\s\\S]*?)(?=\\s+[A-Z][a-z]+:::|$)`);
  const match = str.match(regex);
  if (match) return match[1].trim();
  return str;
};

const Breadcrumb = ({ crumbs }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 4, minWidth: 0 }}>
    {crumbs.map((c, i) => (
      <React.Fragment key={i}>
        {i > 0 && (
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" style={{ flexShrink: 0 }}>
            <path d="M4 2l4 4-4 4" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
        <span style={{
          fontSize: i === crumbs.length - 1 ? 13 : 11,
          fontWeight: i === crumbs.length - 1 ? 700 : 500,
          color: i === crumbs.length - 1 ? '#111827' : '#9ca3af',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          maxWidth: i === 0 ? 200 : undefined,
          flexShrink: i === 0 ? 1 : 0,
        }} title={c}>{c}</span>
      </React.Fragment>
    ))}
  </div>
);

const ModalHeader = ({ crumbs, onClose, actions }) => (
  <Modal.Header style={{
    background: '#f9fafb', borderBottom: '1px solid #e5e7eb',
    padding: '10px 14px', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
    gap: 8
  }}>
    <div style={{ flex: 1, minWidth: 0, overflow: 'hidden' }}>
      <Breadcrumb crumbs={crumbs} />
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexShrink: 0 }}>
      {actions}
      <button type="button" className="btn-close" onClick={onClose} style={{ margin: 0 }} />
    </div>
  </Modal.Header>
);

const Btn = ({ color, disabled, onClick, children }) => (
  <button onClick={onClick} disabled={disabled} style={{
    display: 'inline-flex', alignItems: 'center', gap: 4,
    background: disabled
      ? (color === '#ef4444' ? '#fecaca' : color === '#3b82f6' ? '#bfdbfe' : '#d1d5db')
      : color,
    color: '#fff', border: 'none', borderRadius: 6,
    padding: '6px 12px', fontWeight: 600, fontSize: 12,
    cursor: disabled ? 'not-allowed' : 'pointer', whiteSpace: 'nowrap'
  }}>{children}</button>
);

const DeleteConfirmModal = ({ show, onHide, onConfirm, name, crumbs }) => (
  <Modal show={show} onHide={onHide} centered>
    <ModalHeader crumbs={[...crumbs, 'Silməni Təsdiqlə']} onClose={onHide} />
    <Modal.Body style={{ padding: '20px', background: '#fff', fontSize: 13, color: '#374151' }}>
      <div style={{
        background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8,
        padding: '12px 16px', display: 'flex', gap: 10, alignItems: 'flex-start'
      }}>
        <i className="bi bi-exclamation-triangle-fill" style={{ fontSize: 18, color: '#ef4444', flexShrink: 0 }}></i>
        <span><strong>{parseLang(name)}</strong> adlı elementi silmək istədiyinizə əminsiniz? Bu əməliyyat geri alına bilməz.</span>
      </div>
    </Modal.Body>
    <Modal.Footer style={{
      background: '#f9fafb', borderTop: '1px solid #e5e7eb',
      padding: '10px 16px', display: 'flex', justifyContent: 'flex-end', gap: 8
    }}>
      <Btn color="#6b7280" onClick={onHide}>Ləğv et</Btn>
      <Btn color="#ef4444" onClick={onConfirm}>Bəli, Sil</Btn>
    </Modal.Footer>
  </Modal>
);

const EditFormModal = ({ show, onHide, crumbs, form, onChange, onSave, loading, error, labelName }) => (
  <Modal show={show} onHide={onHide} centered size="md">
    <ModalHeader crumbs={crumbs} onClose={onHide} />
    <Modal.Body style={{ padding: '20px 20px 8px', background: '#fff' }}>
      <div style={{ marginBottom: 14 }}>
        <label style={labelStyle}>{labelName} (AZ) <span style={{ color: '#ef4444' }}>*</span></label>
        <input
          value={form.nameAz}
          onChange={e => onChange({ ...form, nameAz: e.target.value })}
    
          style={{ ...inputStyle, borderColor: error && !form.nameAz.trim() ? '#ef4444' : '#e5e7eb' }}
        />
      </div>
      <div style={{ marginBottom: 14 }}>
        <label style={labelStyle}>{labelName} (RU)</label>
        <input
          value={form.nameRu}
          onChange={e => onChange({ ...form, nameRu: e.target.value })}
          style={inputStyle}
        />
      </div>
      <div style={{ marginBottom: 14 }}>
        <label style={labelStyle}>{labelName} (EN)</label>
        <input
          value={form.nameEn}
          onChange={e => onChange({ ...form, nameEn: e.target.value })}
          style={inputStyle}
        />
      </div>
      <div style={{ marginBottom: 14 }}>
        <label style={labelStyle}>Təsvir</label>
        <textarea
          value={form.description}
          onChange={e => onChange({ ...form, description: e.target.value })}
          placeholder="Qısa məlumat (isteğe bağlı)"
          rows={3}
          style={{ ...inputStyle, resize: 'vertical', minHeight: 72 }}
        />
      </div>
      {error && (
        <div style={{
          background: '#fef2f2', border: '1px solid #fecaca',
          borderRadius: 6, padding: '6px 12px', color: '#dc2626', fontSize: 12, marginBottom: 8
        }}>{error}</div>
      )}
    </Modal.Body>
    <Modal.Footer style={{
      background: '#f9fafb', borderTop: '1px solid #e5e7eb',
      padding: '10px 16px', display: 'flex', justifyContent: 'flex-end', gap: 8
    }}>
      <Btn color="#6b7280" onClick={onHide} disabled={loading}>Ləğv et</Btn>
      <Btn color="#3b82f6" onClick={onSave} disabled={loading}>
        {loading ? <><AppSpinner inline /> Saxlanılır...</> : 'Yadda saxla'}
      </Btn>
    </Modal.Footer>
  </Modal>
);

const TrainingSections = ({ show, onHide, trainingId, trainingName }) => {
  const [sections, setSections]         = useState([]);
  const [loading, setLoading]           = useState(false);
  const [selected, setSelected]         = useState(null);
  const [copiedText, setCopiedText]     = useState('');
  const [modal, setModal]               = useState('');
  const [editForm, setEditForm]         = useState({ nameAz: '', nameRu: '', nameEn: '', description: '' });
  const [editLoading, setEditLoading]   = useState(false);
  const [editError, setEditError]       = useState('');
  const [isDirty, setIsDirty]               = useState(false);
  const [saveOrderLoading, setSaveOrderLoading] = useState(false);
  const [uploadLoading, setUploadLoading]   = useState(false);
  const [uploadError, setUploadError]       = useState('');
  const dragIdx      = useRef(null);
  const dragOverIdx  = useRef(null);
  const syllabusInput = useRef(null);

  const openModal  = (name) => setModal(name);
  const closeModal = ()     => setModal('');

  const fetchSections = useCallback(async () => {
    if (!trainingId) return;
    setLoading(true);
    try {
      const [res] = await Promise.all([
        apiFetch(`${BASE_URL}/sections/training/${trainingId}`),
        new Promise((r) => setTimeout(r, 600)),
      ]);
      const data = await res.json();
      const sorted = (data.sections || []).slice().sort((a, b) => (a.counter ?? 0) - (b.counter ?? 0));
      setSections(sorted);
      setSelected(null);
      setIsDirty(false);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  }, [trainingId]);

  const handleSaveOrder = async () => {
    setSaveOrderLoading(true);
    const payload = { sections: sections.map((s, i) => ({ sectionId: s.id, counter: i + 1 })) };
    try {
      const res = await apiFetch(`${BASE_URL}/sections/update-counters`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) throw new Error();
      setIsDirty(false);
    } catch (e) { console.error(e); }
    finally { setSaveOrderLoading(false); }
  };

  const handleSyllabusUpload = async (e) => {
    const file = e.target.files[0];
    e.target.value = '';
    if (!file) return;
    setUploadLoading(true);
    setUploadError('');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('trainingId', trainingId);
    try {
      const res = await apiFetch(`${BASE_URL}/api/v1/syllabus/upload`, {
        method: 'POST',
        body: formData
      });
      if (!res.ok) {
        let msg = 'Yükləmə zamanı xəta baş verdi.';
        try { const d = await res.json(); msg = d.message || d.error || msg; } catch (_) {}
        throw new Error(msg);
      }
      await fetchSections();
    } catch (err) {
      setUploadError(err.message || 'Yükləmə zamanı xəta baş verdi.');
    } finally {
      setUploadLoading(false);
    }
  };

  const handleDragStart = (i) => { dragIdx.current = i; };
  const handleDragOver  = (e, i) => { e.preventDefault(); dragOverIdx.current = i; };
  const handleDrop      = () => {
    const from = dragIdx.current;
    const to   = dragOverIdx.current;
    if (from === null || to === null || from === to) return;
    const updated = [...sections];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);
    setSections(updated);
    setIsDirty(true);
    dragIdx.current = null;
    dragOverIdx.current = null;
  };

  useEffect(() => {
    if (show && trainingId) fetchSections();
  }, [show, trainingId, fetchSections]);

  const handleOpenEdit = () => {
    if (!selected) return;
    setEditForm({
      nameAz: parseLang(selected.name, 'Az'),
      nameRu: parseLang(selected.name, 'Rus'),
      nameEn: parseLang(selected.name, 'Eng'),
      description: selected.description || ''
    });
    setEditError('');
    openModal('edit');
  };

  const handleEdit = async () => {
    if (!editForm.nameAz.trim()) { setEditError('Bölmə adı (AZ) mütləqdir.'); return; }
    setEditLoading(true);
    const combinedName = `Az::: ${editForm.nameAz.trim()} Rus::: ${editForm.nameRu.trim()} Eng::: ${editForm.nameEn.trim()}`;
    try {
      const res = await apiFetch(`${BASE_URL}/sections`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: selected.id, name: combinedName, description: editForm.description })
      });
      if (!res.ok) throw new Error();
      closeModal(); fetchSections();
    } catch { setEditError('Redaktə edilərkən xəta baş verdi.'); }
    finally { setEditLoading(false); }
  };

  const handleDelete = async () => {
    try {
      const res = await apiFetch(`${BASE_URL}/sections/${selected.id}`, {
        method: 'DELETE',
      });
      if (res.ok) { closeModal(); fetchSections(); }
    } catch (e) { console.error(e); }
  };

  const bc = [trainingName, 'Bölmələr'];

  return (
    <>
      <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 99999 }}>
        <Toast show={!!uploadError} onClose={() => setUploadError('')} delay={5000} autohide bg="danger">
          <Toast.Header closeButton={false}>
            <strong className="me-auto">Xəta</strong>
          </Toast.Header>
          <Toast.Body className="text-white">{uploadError}</Toast.Body>
        </Toast>
      </ToastContainer>

      <Modal show={show} onHide={onHide} centered size="lg" scrollable
        contentClassName="position-relative overflow-hidden">
        <ModalHeader
          crumbs={bc}
          onClose={onHide}
          actions={<>
            <input
              ref={syllabusInput}
              type="file"
              accept=".docx"
              style={{ display: 'none' }}
              onChange={handleSyllabusUpload}
            />
            <Btn color="#2563eb" onClick={fetchSections}>
              <svg viewBox="0 0 20 20" fill="none" style={{ width: 13, height: 13 }}>
                <path d="M4 4a7 7 0 0 1 12 4.9M4 10a7 7 0 0 0 12 4.9M16 4v4h-4M4 16v-4h4"
                  stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </Btn>
            {isDirty && (
              <button onClick={handleSaveOrder} disabled={saveOrderLoading} title="Sıranı yadda saxla" style={{
                width: 28, height: 28, border: 'none', borderRadius: 6,
                background: '#2563eb', color: '#fff',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                cursor: saveOrderLoading ? 'not-allowed' : 'pointer', flexShrink: 0
              }}>
                {saveOrderLoading ? <AppSpinner inline /> : (
                  <svg viewBox="0 0 20 20" fill="none" style={{ width: 13, height: 13 }}>
                    <rect x="3" y="3" width="14" height="14" rx="2" stroke="white" strokeWidth="1.6"/>
                    <rect x="6" y="3" width="8" height="5" rx="1" stroke="white" strokeWidth="1.4"/>
                    <rect x="6" y="11" width="8" height="5" rx="1" stroke="white" strokeWidth="1.4"/>
                    <line x1="8" y1="3" x2="8" y2="8" stroke="white" strokeWidth="1.4"/>
                  </svg>
                )}
              </button>
            )}
            <Btn color="#3b82f6" disabled={!selected} onClick={handleOpenEdit}>Redaktə et</Btn>
            <Btn color="#ef4444" disabled={!selected} onClick={() => openModal('delete')}>Sil</Btn>
            <Btn color="#22c55e" onClick={() => openModal('add')}>+ Yeni Bölmə</Btn>
            <Btn color="#6366f1" disabled={uploadLoading} onClick={() => syllabusInput.current.click()}>
              {uploadLoading ? <><AppSpinner inline /> Yüklənir...</> : (
                <>
                  <svg viewBox="0 0 20 20" fill="none" style={{ width: 13, height: 13 }}>
                    <path d="M10 3v10M6 7l4-4 4 4" stroke="white" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4 15h12" stroke="white" strokeWidth="1.7" strokeLinecap="round"/>
                  </svg>
                  Sillabusu yüklə
                </>
              )}
            </Btn>
          </>}
        />

        <Modal.Body style={{ padding: 0, background: '#fff', minHeight: 300 }}>
          <AppSpinner show={loading} text="Bölmələr yüklənir..." minMs={200} />
          {!loading && (sections.length > 0 ? (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                <thead>
                  <tr style={{ background: '#f3f4f6', position: 'sticky', top: 0, zIndex: 5 }}>
                    <th style={{ ...thStyle, width: 28, padding: '8px 6px' }}></th>
                    <th style={thStyle}>KOD</th>
                    <th style={thStyle}>BÖLMƏ ADI</th>
                    <th style={thStyle}>TƏSVİR</th>
                    <th style={{ ...thStyle, textAlign: 'right' }}>TARİX</th>
                  </tr>
                </thead>
                <tbody>
                  {sections.map((s, idx) => {
                    const isSel = selected?.id === s.id;
                    const displayName = parseLang(s.name);
                    const displayDesc = parseLang(s.description);
                    return (
                      <tr key={s.id}
                        draggable
                        onDragStart={() => handleDragStart(idx)}
                        onDragOver={e => handleDragOver(e, idx)}
                        onDrop={handleDrop}
                        onDragEnd={() => { dragIdx.current = null; dragOverIdx.current = null; }}
                        onClick={(e) => setSelected(e.ctrlKey && isSel ? null : s)}
                        onDoubleClick={() => { setSelected(s); openModal('lectures'); }}
                        style={{
                          borderBottom: '1px solid #e5e7eb', height: 35,
                          cursor: 'grab', background: isSel ? '#eff6ff' : '#fff',
                          transition: 'background 0.15s'
                        }}
                        onMouseEnter={e => { if (!isSel) e.currentTarget.style.background = '#f3f4f6'; }}
                        onMouseLeave={e => { e.currentTarget.style.background = isSel ? '#eff6ff' : '#fff'; }}
                      >
                        <td style={{ ...tdStyle, padding: '6px', color: '#d1d5db', cursor: 'grab', userSelect: 'none' }}>
                          <svg viewBox="0 0 16 16" fill="currentColor" style={{ width: 14, height: 14, display: 'block', margin: '0 auto' }}>
                            <circle cx="5" cy="4" r="1.2"/><circle cx="11" cy="4" r="1.2"/>
                            <circle cx="5" cy="8" r="1.2"/><circle cx="11" cy="8" r="1.2"/>
                            <circle cx="5" cy="12" r="1.2"/><circle cx="11" cy="12" r="1.2"/>
                          </svg>
                        </td>
                        <td style={tdStyle}>
                          <span style={{
                            background: '#eff6ff', color: '#1d4ed8', padding: '2px 8px',
                            borderRadius: 4, fontWeight: 700, fontSize: 11, border: '1px solid #bfdbfe'
                          }}>#{s.id}</span>
                        </td>
                        <td style={{ ...tdStyle, fontWeight: 600, color: '#111827' }} onClick={() => setCopiedText(displayName)}>
                          {displayName}
                        </td>
                        <td style={{ ...tdStyle, color: '#6b7280', maxWidth: 250, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                          title={displayDesc} onClick={() => setCopiedText(displayDesc)}>
                          {displayDesc || '—'}
                        </td>
                        <td style={{ ...tdStyle, textAlign: 'right', color: '#6b7280' }} onClick={() => setCopiedText(s.register ? s.register.split('T')[0] : '')}>
                          {s.register ? s.register.split('T')[0] : '—'}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '60px 0', color: '#9ca3af' }}>
              <i className="bi bi-folder2-open" style={{ fontSize: 36, marginBottom: 10, display: 'block', color: '#d1d5db' }}></i>
              <h6 style={{ fontWeight: 700, color: '#374151', marginBottom: 4 }}>Hələ ki bölmə yoxdur</h6>
              <p style={{ fontSize: 12, color: '#6b7280', margin: 0 }}>Bu təlim üçün alt bölmə təyin edilməyib.</p>
            </div>
          ))}
        </Modal.Body>
        <CopyFooter value={copiedText} />
        {modal && (
          <div style={{
            position: 'absolute', inset: 0, zIndex: 10,
            background: 'rgba(0,0,0,0.5)',
            borderRadius: 'inherit'
          }} />
        )}
      </Modal>

      <EditFormModal show={modal === 'edit'} onHide={closeModal}
        crumbs={[trainingName, 'Bölmələr', 'Redaktə']}
        form={editForm} onChange={setEditForm}
        onSave={handleEdit} loading={editLoading} error={editError}
        labelName="Bölmə Adı" />

      <DeleteConfirmModal show={modal === 'delete'} onHide={closeModal}
        onConfirm={handleDelete} name={selected?.name} crumbs={bc} />

      <AddSectionModal show={modal === 'add'} onHide={closeModal}
        trainingId={trainingId} trainingName={trainingName} onSuccess={fetchSections} />

      <SectionLectures show={modal === 'lectures'} onHide={closeModal}
        sectionId={selected?.id} sectionName={selected?.name} trainingName={trainingName} trainingId={trainingId} />
    </>
  );
};

export default TrainingSections;